import axios from 'axios';
import api from '../api';

export default {
    CREATE_INTERNAL_NOTES: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL + api.internalnotes.CREATE_INTERNAL_NOTES(), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },

    GET_INTERNAL_NOTES: (query) => {
        return new Promise((resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;

            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.internalnotes.GET_INTERNAL_NOTES(query))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },

    GET_ALL_INTERNAL_NOTES: (data) => {
        return new Promise((resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;

            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.internalnotes.GET_ALL_INTERNAL_NOTES(data))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },

    DELETE_INTERNAL_NOTES: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .delete(process.env.REACT_APP_BACKEND_URL + api.internalnotes.DELETE_INTERNAL_NOTES(id))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
};
